/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Mfa_Submit_ButtonInputs */

const de_auth_mfa_submit_button = /** @type {(inputs: Auth_Mfa_Submit_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestätigen`)
};

/** @type {(inputs: Auth_Mfa_Submit_ButtonInputs) => LocalizedString} */
const en_auth_mfa_submit_button = de_auth_mfa_submit_button;

/**

* @param {Auth_Mfa_Submit_ButtonInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_mfa_submit_button = /** @type {((inputs?: Auth_Mfa_Submit_ButtonInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Mfa_Submit_ButtonInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_mfa_submit_button(inputs)
	return en_auth_mfa_submit_button(inputs)
});